import { render, staticRenderFns } from "./AppPaginacionPerPage.vue?vue&type=template&id=7cc5dd46&scoped=true"
import script from "./AppPaginacionPerPage.vue?vue&type=script&lang=js"
export * from "./AppPaginacionPerPage.vue?vue&type=script&lang=js"
import style0 from "./AppPaginacionPerPage.vue?vue&type=style&index=0&id=7cc5dd46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc5dd46",
  null
  
)

export default component.exports